import {ServiceOptionsQueries} from '../../api/service'

export const ServiceOptionsService = {
  queries: ServiceOptionsQueries
}
